import React, { useState } from "react";


// import { GiHamburgerMenu } from "react-icons"
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FaTimes } from "react-icons/fa";
import Home from "../Pages/Home";
import About from "../Pages/About";
import Project from "../Pages/Project";
import Skill from "../Pages/Skill";
import Contact from "../Pages/Contact";

import "../style/navbar.css";


export default function Navbar() {

  const [click, setClick] = useState(true);

  const handleclick = () => {
   setClick(!click)
  }



  return (
    <div >

    <div className="maindivnav">
      
        <a >
        <h1 id="headingname"> KAILASH CHANDRA</h1>
       </a>

        <ul className={click ? "nav-menu active" : "nav-menu "}>
        <li onClick={handleclick}>
         
          <a href="#home" >Home</a>
        </li>

        <li onClick={handleclick}>
         
          <a href="#about">About</a>
        </li>
        <li onClick={handleclick}>
         
          <a href="#skill">Skills</a>
        </li>
        <li onClick={handleclick}>
         
          <a href="#project">Project</a>
        </li>

        <li onClick={handleclick}>
         
          <a href="#contact">Contact</a>
        </li>


        <li>
      
          <a href='./Kailash_Chandra_Resume.pdf'
           target="_blank" 
            download 
            onClick=
            {()=>window.open("https://drive.google.com/file/d/1ZLwfIroggXPMbYEVkA2_fJhRktRRCC-y/view?usp=sharing")}>Resume</a>
        </li>
        
      </ul>


     
      <div className="hamburger" onClick={handleclick}>


            {click ? (

              <FaTimes size={25} style={{ color: "white" }} />
             ) : (
              <FaBars size={25} style={{ color: "white" }} />
            )}

       </div>

     

 </div>
      


     
     





      <div>
         <section id="home" className="home">
         <Home/>

         </section>



         <section id="about" className="about">
         <About/>
            
         </section>


         <section id="skill" className="skill">
         <Skill/>
            
         </section>


         <section id="project" className="project">
         <Project/>
            
         </section>


         


         <section id="contact" className="contact">
         <Contact/>
            
         </section>




      </div>

      

    </div>


  )
}
